import { makeAutoObservable, flow } from 'mobx';
import { zhCNStr } from '@/constants';
import { postLogout } from '@/api/Dialogs/signUpDlg';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import { settingPictures } from '@/api/personCenter/organization';
import { getVipInfo } from '&/api/personCenter/projectSpace';
import LogoImage from '&/assets/img/logo/hd_ent_logo.svg';

const TOKEN_KEY = 'hdcBusinessToken';
const INFO_KEY = 'hdcBusinessUserInfo';
const WCP_TOKEN_KEY = 'hdcWcpToken';
const WCP_FLAG = 'isWcp';
const REMEMBER_ME = 'rememberMeBusiness';
const ORGANIZATION_KEY = 'organization';
const PROJECTLAYOUTICON = 'projectLayoutIcon';
const SKIP_NOTE_DWG = 'skiNoteDWG';

class AppStore {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    useLocalStorage = localStorage.getItem(REMEMBER_ME) || false;

    lang = this.getStorageMode.getItem('hdcLang') || zhCNStr;

    userInfo = JSON.parse(this.getStorageMode.getItem(INFO_KEY)) || {};
    organization =
        JSON.parse(this.getStorageMode.getItem(ORGANIZATION_KEY)) || {};

    isWcp = JSON.parse(this.getStorageMode.getItem(WCP_FLAG));

    token = this.isWcp
        ? this.getStorageMode.getItem(WCP_TOKEN_KEY)
        : this.getStorageMode.getItem(TOKEN_KEY);

    projectLayoutIcon =
        this.getStorageMode.getItem(PROJECTLAYOUTICON) || 'Icon-List-List';

    noteDwg = this.getStorageMode.getItem(SKIP_NOTE_DWG) || false;

    logoURL = LogoImage;

    get getStorageMode() {
        const parsedVal = JSON.parse(this.useLocalStorage);
        return parsedVal ? localStorage : sessionStorage;
    }

    skipNoteDwg(checked) {
        this.noteDwg = checked;
        this.getStorageMode.setItem(SKIP_NOTE_DWG, checked);
    }

    rememberMe(checked) {
        if (checked !== undefined) {
            this.useLocalStorage = checked;
            localStorage.setItem(REMEMBER_ME, checked);
        }
    }

    changeLang(lang) {
        this.lang = lang;
    }

    setToken(str, isWcp) {
        if (!str) return;
        this.token = str;
        this.isWcp = isWcp;
        this.getStorageMode.setItem(WCP_FLAG, isWcp);
        this.getStorageMode.setItem(isWcp ? WCP_TOKEN_KEY : TOKEN_KEY, str);
    }

    removeToken() {
        this.token = null;
        this.getStorageMode.removeItem(TOKEN_KEY);
        this.getStorageMode.removeItem(WCP_TOKEN_KEY);
    }

    get isLogIn() {
        return !!this.token;
    }

    queryUserInfo = flow(function* () {
        let entId =
            this.organization?.branchId || this.organization?.enterpriseId;
        if (!entId) return;
        const { data = {} } = yield getUserInfo({ entId });

        this.setUserInfo({ ...this.userInfo, ...data });
    });

    setUserInfo(obj = {}) {
        this.userInfo = obj;
        console.log('this.userInfo', this.userInfo);
        this.getStorageMode.setItem(INFO_KEY, JSON.stringify(obj));
    }

    removeUserInfo() {
        this.userInfo = {};
        this.getStorageMode.removeItem(INFO_KEY);
    }

    getOrganization() {
        return this.organization;
    }

    getProjectLayoutIcon() {
        return this.getStorageMode.getItem('PROJECT_LAYOUT');
    }

    setOrganization(obj = {}) {
        this.organization = obj;
        this.getStorageMode.setItem(ORGANIZATION_KEY, JSON.stringify(obj));
        localStorage.setItem('organization', JSON.stringify(obj));
    }
    removeOrganization() {
        this.organization = {};
        this.getStorageMode.removeItem(ORGANIZATION_KEY);
    }

    setLoginData(data, isWcp) {
        this.setToken(data.token, isWcp);
        this.setUserInfo(data.userinfo);
    }
    setPersonalLoginData(data, isWcp) {
        this.getStorageMode.setItem('hdcToken', data.token);
        this.getStorageMode.setItem(
            'hdcUserInfo',
            JSON.stringify(data.userinfo)
        );
        localStorage.setItem('rememberMe', this.useLocalStorage);
    }
    async logout() {
        const { code } = await postLogout();
        if (code !== 0) return Promise.reject();
        this.clearLoginData();
        window.location.reload();
        return Promise.resolve();
    }
    clearLoginData() {
        this.removeUserInfo();
        this.removeToken();
        this.removeOrganization();
    }

    isShowSignUpDlg = false; // 是否显示注册对话框

    isShowSignInDlg = false; // 是否显示登录对话框

    isShowOrganizationSelectDlg = false; // 是否显示组织选择弹框

    isShowApplyTrialDlg = false; // 是否显示申请试用对话框

    setSignUpDlgVisable(visable) {
        this.isShowSignUpDlg = visable;
        this.isShowSignInDlg = !visable;
        this.isShowApplyTrialDlg = !visable;
        this.isShowOrganizationSelectDlg = !visable;
    }

    setSignInDlgVisable(visable) {
        this.isShowSignInDlg = visable;
        this.isShowSignUpDlg = false;
        this.isShowApplyTrialDlg = false;
        this.isShowOrganizationSelectDlg = false;
    }
    setApplyTrialDlgVisible(visable) {
        this.isShowApplyTrialDlg = visable;
        this.isShowSignInDlg = !visable;
        this.isShowSignUpDlg = !visable;
        this.isShowOrganizationSelectDlg = !visable;
    }
    setOrganizationSelectDlg(visable) {
        this.isShowOrganizationSelectDlg = visable;
        this.isShowApplyTrialDlg = !visable;
        this.isShowSignInDlg = !visable;
        this.isShowSignUpDlg = !visable;
    }

    // type = SignIn | SignUp
    setModalVisible(type, bool) {
        this[`isShow${type}Dlg`] = bool;
    }

    isHideHeader = false; //是否显示header 上的路由和登录

    setHeaderHide(hide) {
        this.isHideHeader = hide;
    }

    setPDFviwer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }

    getPDFviwer() {
        return this.pdfViewer;
    }

    isFreeUseLogin = false;

    setIsFreeUseLogin(flag) {
        this.isFreeUseLogin = flag;
    }

    isNeedMobile = false;
    setIsNeedMobile(bool) {
        this.isNeedMobile = bool;
    }

    isPdfChange = false;

    setIsPdfChange(flag) {
        this.isPdfChange = flag;
    }

    changeProjectLayoutIcon(val) {
        if (val) {
            this.getStorageMode.setItem(PROJECTLAYOUTICON, val);
            this.projectLayoutIcon = val;
            return;
        }
        if (this.projectLayoutIcon === 'Icon-List-List') {
            this.getStorageMode.setItem(PROJECTLAYOUTICON, 'Icon-List-Thumb');
            this.projectLayoutIcon = 'Icon-List-Thumb';
        } else if (this.projectLayoutIcon === 'Icon-List-Thumb') {
            this.getStorageMode.setItem(PROJECTLAYOUTICON, 'Icon-List-List');
            this.projectLayoutIcon = 'Icon-List-List';
        }
    }

    remoteLogo = ''; // 上传的企业logo

    setRemoteLogo(str) {
        this.remoteLogo = str;
    }

    getLogoURL() {
        if (!this.isLogIn) return Promise.resolve();
        return settingPictures({
            type: 1,
            dap: 1,
            entId: this.organization.enterpriseId,
        }).then(res => {
            if (res.data) {
                const { logo_url } = res.data;
                this.setRemoteLogo(logo_url);
                logo_url && (this.logoURL = logo_url);
            }
        });
    }
    setLogoURL(dataURL) {
        this.logoURL = dataURL;
    }

    loginType = 'normal'; // example = 示例项目组织

    setLoginType(str) {
        this.loginType = str;
    }

    vipDuration = -1;

    getVipInfo() {
        return getVipInfo().then(res => {
            if (
                res.data &&
                (res.data.surplusDuration || res.data.surplusDuration === 0)
            ) {
                this.vipDuration = res.data.surplusDuration;
            }
        });
    }
}
const appStore = new AppStore();

export default appStore;
